import {Route} from '@angular/router';
import {initialDataResolver} from 'app/app.resolvers';
import {AuthGuard} from 'app/core/auth/guards/auth.guard';
import {NoAuthGuard} from 'app/core/auth/guards/noAuth.guard';
import {LayoutComponent} from 'app/layout/layout.component';

export const appRoutes: Route[] = [

    // Redirect empty path to '/customer-dashboard'
    {path: '', pathMatch: 'full', redirectTo: 'recycling/utility'},

    // Redirect signed-in user to the '/customer-dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'recycling/utility'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')}
        ]
    },

    // Customer routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {
                path: 'recycling', children: [
                    {
                        path: 'utility',
                        loadChildren: () => import('app/modules/return-wizard/return-wizard.routes')
                    },
                    {
                        path: 'complete/:returnId',
                        loadChildren: () => import('app/modules/return-wizard/step-5-confirmation/return-complete.routes')
                    },
                ]
            }
        ]
    },

    // Reports
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {
                path: 'reports', children: [
                    {
                        path: 'line-item-report',
                        loadChildren: () => import('app/modules/reports/line-item-report/line-item-reports.routes')
                    },
                    {
                        path: 'net-suite-export',
                        loadChildren: () => import('app/modules/reports/net-suite-export/net-suite-export.routes')
                    }
                ]
            }
        ]
    }
];
